import React from 'react';
import { SvgIcon } from '@material-ui/core';

const AppleSVGIcon = () => (
  <SvgIcon>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g id="surface1">
        <path d="M 12.152344 6.894531 C 11.203125 6.894531 9.738281 5.816406 8.191406 5.855469 C 6.152344 5.882812 4.28125 7.039062 3.230469 8.871094 C 1.113281 12.546875 2.683594 17.972656 4.75 20.960938 C 5.761719 22.414062 6.957031 24.050781 8.542969 24 C 10.0625 23.933594 10.632812 23.011719 12.476562 23.011719 C 14.308594 23.011719 14.828125 24 16.4375 23.960938 C 18.074219 23.933594 19.113281 22.480469 20.113281 21.011719 C 21.269531 19.324219 21.75 17.6875 21.773438 17.597656 C 21.734375 17.585938 18.59375 16.375 18.554688 12.738281 C 18.527344 9.699219 21.035156 8.246094 21.152344 8.179688 C 19.722656 6.089844 17.527344 5.855469 16.761719 5.804688 C 14.761719 5.648438 13.085938 6.894531 12.152344 6.894531 Z M 15.53125 3.828125 C 16.371094 2.816406 16.929688 1.402344 16.773438 0 C 15.566406 0.0507812 14.113281 0.804688 13.242188 1.816406 C 12.464844 2.714844 11.789062 4.15625 11.96875 5.53125 C 13.308594 5.636719 14.683594 4.84375 15.527344 3.832031 " />
      </g>
    </svg>
  </SvgIcon>
);

export default AppleSVGIcon;
